import { DatePipe } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormService } from 'src/app/core/util/form.service';

import { ValidPostingPeriodAuthFormComponent } from '../components/valid-posting-period-auth/valid-posting-period-auth.component';

@Injectable()
export class ValidPostingPeriodCheckingService {
  constructor(
    private injector: Injector,
    private http: _HttpClient,

    private fs: FormService
  ) { }

  get modalService() {
    return this.injector.get(NzModalService);
  }

  check(date: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post('api/ValidPostingPeriods/CheckRule?_silent=true', { date: date }).subscribe(res => {
        if (res.rule === 'Block') {
          this.modalService.error({
            nzTitle: 'Valid Posting Period Violation',
            nzContent: res.message,
            nzOnOk: () => reject(false),
            nzOkText: 'Cancel',
            nzOnCancel: () => reject(false),
          });
        }
        else if (res.rule === 'Warning') {
          this.modalService.confirm({
            nzTitle: 'Valid Posting Period Violation',
            nzContent: res.message,
            nzOnOk: () => resolve(true),
            nzOkText: 'Save',
            nzOnCancel: () => reject(false),
          });
        }
        else if (res.rule === 'NeedPassword') {
          const messages = res.message.split('<br />');
          const content = { id: res.id, email: '', password: '', message1: messages[0], message2: messages[1] };
          const modal = this.modalService.create({
            nzTitle: 'Valid Posting Period Violation',
            nzContent: ValidPostingPeriodAuthFormComponent,
            nzWidth: '450px',
            nzOnOk: component => {
              return new Promise((resolve, reject) => {
                if (!this.fs.validate(component.form).isValid) {
                  reject(false);
                }
                else {
                  this.http.post('api/ValidPostingPeriods/VerifyApprover', component.form.value).subscribe({
                    next: () => resolve(true),
                    error: () => reject(false)
                  });
                }
              })
                .then(() => resolve(true));
            },
            nzOnCancel: () => reject(false),
          });
          const instance = modal.getContentComponent();
          instance.value = content;
        }
        else {
          resolve(true);
        }
      });
    });
  }
}
